import { render, staticRenderFns } from "./SignalsPlans.vue?vue&type=template&id=b6bc35d8&"
import script from "./SignalsPlans.vue?vue&type=script&lang=js&"
export * from "./SignalsPlans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports